<template>
  <limitedlayout>
    <div class="row mb-3">
      <div class="col-lg-12 col-xs-12 pr-2">
        <div class="block_info_white p-2">
          <div class="row">
            <div
              class="col-lg-6 col-xs-12 text-truncate"
              style="width: 100%"
            >
              <div class="form-group color-dark-purple mb-0">
                <h5 class="label-bold">
                  CANDIDATO(A)S DA VAGA
                  <span style="color: #8f66fe">{{ job.title }}</span>
                </h5>
              </div>
            </div>
            <div class="col-lg-4 col-xs-12">
              <inertia-link
                class="color-primary "
                :href="`/recruiters/limited_jobs/${job.id}/kanban`"
              >
                <button class="btn-new-job"  style="max-height: 30px;max-width: 200px; font-size: 12px; ">KANBAN</button>
              </inertia-link>

            </div>
            <div class="col-lg-2">
              <a
                target="_blank"
                :href="'/recruiters/jobs/'+job.id+'/applies/export.csv'"
              >
                <button
                  type="button"
                  class="btn btn-success f10"
                >DOWNLOAD CSV</button>
              </a>
              <a
                target="_blank"
                :href="'/recruiters/jobs/'+job.id+'/applies/export_evaluations.csv'"
              >
                <button
                  type="button"
                  class="btn btn-success mt-2 f10"
                >DOWNLOAD CSV PROVA</button>
              </a>
            </div>
          </div>
          <div class="row mt-3">
            <div class="col-lg-3 col-xs-12 p-0">
              <select
                class="form-control f14"
                v-model="action"
                @change="changeAction"
                :disabled="!selected.length"
              >
                <option
                  disabled
                  value="0"
                >AÇÕES</option>
                <option value="1">COMPARTILHAR</option>
                <option value="2">MUDAR STATUS</option>
                <option value="3">REMOVER CANDIDATO</option>
                <option value="4">DOWNLOAD DOS PERFIS</option>
              </select>
              <label class="pt-2 position-absolut-top">
                <input
                  type="checkbox"
                  v-model="visibility"
                />
                <b>Mostar movidos</b>
              </label>
            </div>
            <div class="col-lg-3">
              <div
                style="
                  width: 95px;
                  height: 38px;
                  margin-right: 10px !important;
                  border: 1px solid rgb(177, 176, 176);
                "
                class="nav filter-box-applie"
              >
                <li class="pointer nav-item dropdown">
                  <div
                    class="nav-link f12"
                    style="width: 110px; height: 38px"
                    data-toggle="dropdown"
                    role="button"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="left">
                      <font-awesome-icon
                        icon="ellipsis-v"
                        class="mr-2"
                      />
                    </span>
                    <span class="left">FILTRO</span>
                  </div>
                  <div class="dropdown-menu f10">
                    <div class="dropdown-item pointer">
                      <label class="pt-2">
                        <input
                          type="checkbox"
                          v-model="visibility"
                        />
                        <b>CANDIDATO(A)S REMOVIDOS</b>
                      </label>
                    </div>
                    <div class="dropdown-item pointer">
                      <label class="pt-2">
                        <input
                          type="checkbox"
                          v-model="complete_videos"
                        />
                        <b>CANDIDATO(A)S COM VÍDEO</b>
                      </label>
                    </div>
                    <div class="dropdown-item pointer">
                      <label class="pt-2">
                        <input
                          type="checkbox"
                          v-model="curriculum"
                        />
                        <b>CANDIDATO(A)S COM CURRICULUM</b>
                      </label>
                    </div>
                  </div>
                </li>
              </div>
            </div>

            <div class="col-lg-3"></div>
            <div class="col-lg-3 col-xs-12 pl-0">
              <div class="form-group mb-0 has-search d-flex justify-content-end">
                <span
                  class="fa fa-search ml-2 mt-2 mr-3 form-control-feedback"
                  style="color: #212529"
                ></span>
                <input
                  type="text"
                  v-model="search"
                  v-on:keyup.enter="searchApplies"
                  class="form-control no_border"
                  style="padding: 0px"
                />
                <div class="total_apply color-dark-purple f12">
                  <span><b>{{ totalApplies }} CANDIDATO(A)S</b></span>
                </div>
              </div>
            </div>
            <div
              v-if="is_admin"
              class="col-lg-2 col-xs-12"
              style="margin-top: 10px"
            ></div>
          </div>
        </div>
      </div>
      <div class="col-lg-12 col-xs-12 mt-3">
        <div class="table-responsive">

          <table class=" table mt-3 f12">
            <thead class="headerTable">
              <tr>
                <td style="width: 5px;"></td>
                <td style="min-width: 400px;">
                  CANDIDATO(A)S
                  <OrderTable
                    field="name"
                    entity="applies"
                  />
                </td>
                <td
                  style="min-width: 200px;"
                >
                  
                  <HeaderAgg  :aggs="aggs['selective_process_name']" name="STATUS" entity="applies" field="selective_process_name" width="200px" />
                  
                  <!-- <OrderTable
                    style="width: 20px; float: left;"
                    field="selective_process_id"
                    entity="applies"

                  /> -->
                </td>
                <td
                  style="min-width: 200px"
                >
                  E-MAIL
                  <OrderTable
                    entity="applies"
                    field="email"
                  />
                </td>
                <td
                  style="min-width: 200px"
                >
                  TELEFONE
                  <OrderTable
                    entity="applies"
                    field="date_birth"
                  />
                </td>
                <td
                  style="min-width: 200px;"
                >
                  NASCIMENTO
                  <OrderTable
                    entity="applies"
                    field="date_birth"
                  />
                </td>
                <td
                  style="min-width: 250px !important;"
                >
                  TESTE
                  <OrderTable
                    entity="applies"
                    field="point"
                  />
                </td>
                <td
                  style="min-width: 200px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['last_role']" name="CARGO" entity="applies" field="last_role" width="200px" />
                  </div>
                </td>
                <td
                  style="min-width: 200px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['last_business']" name="EMPRESA" entity="applies" field="last_business" width="200px" />
                  </div>
                </td>
                <td
                  style="min-width: 200px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['hometown']" name="CIDADE NATAL" entity="applies" field="hometown" width="200px" />
                  </div>
                </td>
                <td
                  style="min-width: 200px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['city']" name="CIDADE ATUAL" entity="applies" field="city" width="200px" />
                  </div>
                </td>
                <td
                  style="min-width: 200px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['ethnicity']" name="ETNIA" entity="applies" field="ethnicity" width="200px" />
                  </div>
                </td>
                <td
                  style="min-width: 300px;"
                >
                  GÊNERO
                  <OrderTable
                    entity="applies"
                    field="gender"
                  />
                </td>
                <td
                  style="min-width: 300px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['sexual_orientation']" name="ORIENTAÇÃO SEXUAL" entity="applies" field="sexual_orientation" width="300px" />
                  </div>
                </td>
                <td
                  style="min-width: 200px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['is_pcd']" name="PCD" entity="applies" field="is_pcd" width="200px" />
                  </div>
                </td>
                <td
                  style="min-width: 400px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['been_creditsuisse']" name="JÁ TRABALHOU NA CREDIT SUISSE?" entity="applies" field="been_creditsuisse" width="400px" />
                  </div>
                </td>
                <td
                  style="min-width: 350px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['current_creditsuisse']" name="TRABALHA NA CREDIT SUISSE?" entity="applies" field="current_creditsuisse" width="350px" />
                  </div>
                </td>
                <td
                  style="min-width: 350px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['source']" name="COMO FICOU SABENDO?" entity="applies" field="source" width="300px" />
                  </div>
                </td>
                <td 
                  style="min-width: 250px;"
                >
                  DATA DE INSCRIÇÃO
                  <OrderTable
                    entity="applies"
                    field="created_at"
                  />
                </td>
                <td 
                  class="center"
                  style="min-width: 250px;"
                >
                  <div v-if="applies.length > 0">

                    <HeaderAgg :aggs="aggs['languages']" name="Idiomas" entity="applies" field="languages" width="200px" />
                  </div>
                 
                </td>
                <td 
                  class="center"
                  style="min-width: 250px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['company_names']" name="Empresas" entity="applies" field="company_names" width="200px" />
                  </div>                 
                </td>
                <td 
                  class="center"
                  style="min-width: 250px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['occupation_names']" name="Cargos" entity="applies" field="occupation_names" width="200px" />
                  </div>                 
                </td>
                <td 
                  class="center"
                  style="min-width: 250px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['institution_names']" name="Instituições" entity="applies" field="institution_names" width="200px" />
                  </div>                 
                </td>
                 <td 
                  class="center"
                  style="min-width: 250px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['study_area_names']" name="Formações" entity="applies" field="study_area_names" width="200px" />
                  </div>                 
                </td>
                <td 
                  class="center"
                  style="min-width: 250px;"
                >
                  <div v-if="applies.length > 0">
                    <HeaderAgg :aggs="aggs['formation_type']" name="Tipo de curso" entity="applies" field="formation_type" width="200px" />
                  </div>                 
                </td>
                <td></td>
                <td></td>
              </tr>
            </thead>
            <tbody class="position-relative">
              <tr
                v-for="(apply, index) in applies"
                :key="apply.id"
                :class="{ 'content-loading': loading }"
              >
                <td
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                  style="border-left: 1px solid #fff"
                  :style="{
                  borderLeftColor:
                    apply.tag_color != null ? apply.tag_color : '#fff',
                  borderLeftWidth: '5px',
                }"
                >
                  <CheckBox
                    :id="apply"
                    :index="index"
                    :checked="selected_ids.includes(apply.id)"
                  />
                </td>
                <td 
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  <div class="d-flex flex-row">
                    <div>
                      <div
                        class="avatar_thumb pointer"
                        @click="show(apply.id, apply.candidate_id, index)"
                      >
                        <img
                          class
                          :src="apply.image || '/images/avatar.png'"
                        />
                      </div>
                      <font-awesome-icon
                        v-if="apply.status >= 1"
                        icon="eye"
                        class="eye f11"
                        style="color: #666464; margin-left: 55px"
                      ></font-awesome-icon>
                      <font-awesome-icon
                        v-if="apply.status == 0"
                        icon="eye-slash"
                        class="eye f11"
                        style="color: #b7b7b7; margin-left: 55px"
                      ></font-awesome-icon>
                    </div>
                    <div class="ml-3 mt-1">
                      {{ apply.name }}<br />
                      <span
                        class="f10"
                        v-if="apply.tag_name != null"
                      >
                        <i class="fas fa-user-tag color-primary pr-1"></i>
                        {{ apply.tag_name }}
                      </span>
                    </div>
                  </div>
                </td>
                <!-- <td :class="{selected: selected_ids.includes(apply.id)}" class="pt-3">
                <div :class="`status${apply.status}`">{{status[apply.status]}}</div>
              </td>-->
                <td
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                  class="pt-3"
                >
                  <div
                    class="block_process"
                    style="border-radius: 0px"
                    :class="`process${apply.selective_process_status}`"
                  >
                    {{ apply.selective_process_name }}
                  </div>
                </td>

                <td
                  class="pt-3 color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{ apply.email ? apply.email : 'Não informado' }}
                </td>

                <td 
                  class="pt-3 color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{ apply.mobile_phone ? apply.mobile_phone : 'Não informado' }}
                </td>

                <td
                  class="pt-3 color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{ formattedDate(apply.date_birth) }}
                </td>
                
                <td
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{ hitsPercentage(apply) }}
                </td>

                <td 
                  class="pt-3 color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{ apply.last_role }}
                </td>

                <td 
                  class="pt-3 color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{ apply.last_business }}
                </td>

                <td 
                  class="pt-3 color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{ apply.hometown_attributes ? 
                    `${apply.hometown_attributes.name}/${apply.hometown_state_attributes.name}`:
                    `Não definido`
                  }}
                </td>

                 <td 
                  class="pt-3 color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{ apply.city_attributes ? 
                    `${apply.city_attributes.name}/${apply.state_attributes.name}`:
                    `Não definido`
                  }}
                </td>

                <td 
                  class="pt-3 color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{ getEthnicity(apply.ethnicity) || "Não definido" }}
                </td>

                <td
                  class="pt-3 color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{ getGender(apply.gender) || "Não definido" }}
                </td>

                <td 
                  class="pt-3 color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{ getSexualOrientation(apply.sexual_orientation) || "Não definido" }}
                </td>

                <td 
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                  class="pt-3 color-dark-purple"
                >
                  {{ apply.is_pcd ? apply.pcd_description : "Não" }}
                </td>
                
                <td
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                  class="pt-3 color-dark-purple"
                >
                  {{ apply.been_creditsuisse ? 'Sim' : 'Não' }}
                </td>

                <td
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                  class="pt-3 color-dark-purple"
                >
                  {{ apply.current_creditsuisse ? 'Sim' : 'Não' }}
                </td>

                <td
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                  class="pt-3 color-dark-purple"
                >
                  {{ apply.source ? apply.source : 'Não informado' }}
                </td>

                <td
                  class="pt-3 color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  {{ formattedDate(apply.created_at) }}
                </td>

                <td
                  class="pt-3 center color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  <span class="chip" v-for="(lang) in apply.languages "  :key="apply.id+lang">
                    {{ lang }}
                  </span>
                 
                </td>

                <td
                  class="pt-3 center color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  <span class="chip" v-for="(company, index) in apply.company_names "  :key="apply.id+company+index">
                    {{ company }}
                  </span>
                 
                </td>

                <td
                  class="pt-3 center color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  <span class="chip" v-for="(occupation, index) in apply.occupation_names "  :key="apply.id+occupation+index">
                    {{ occupation }}
                  </span>
                </td>

                <td
                  class="pt-3 center color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  <span class="chip" v-for="(institution) in apply.institution_names "  :key="apply.id+institution">
                    {{ institution }}
                  </span>
                </td>

                <td
                  class="pt-3 center color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  <span class="chip" v-for="(study_area, index) in apply.study_area_names"  :key="apply.id+study_area+index">
                    {{ study_area }}
                  </span>
                </td>

                <td
                  class="pt-3 center color-dark-purple"
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  <span class="chip" v-for="(formation, index) in apply.formation_type "  :key="apply.id+formation+index">
                    {{ formation }}
                  </span>
                </td>

                <td
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                  class="pt-3"
                >
                  <div
                    @click="show(apply.id, apply.candidate_id, index)"
                    class="pointer"
                  >
                    <i class="fas f25 color-primary fa-file-alt"></i>
                  </div>
                </td>
                <td
                  :class="{
                    selected: selected_ids.includes(apply.id),
                    opacity: apply.visibility == false,
                  }"
                >
                  <a
                    target="_blank"
                    class="color-primary"
                    :href="`/recruiters/applies/${apply.id}/download.pdf`"
                    download
                  >
                    <i class="fa  f25 color-primary  fa-file-pdf" aria-hidden="true"></i>
                </a>

                
                </td>
              </tr>
              <div
                class="position-absolute loading-gif"
                :class="{ 'd-none': !loading || firstLoad }"
              >
                <img
                  src="/images/loading.gif"
                  alt="loading-gif"
                />
              </div>
            </tbody>
          </table>
        </div>
      
        <v-pagination
          v-model="currentPage"
          :page-count="pageCount"
          class="justify-content-center"
          :class="firstLoad ? 'd-none' : 'd-flex'"
          :classes="bootstrapPaginationClasses"
        ></v-pagination>
        
      </div>
    </div>
  </limitedlayout>
</template>

<script>
import moment from "moment";
import ApplyShow from "@/Recruiters/Applies/Show.vue";
import StarRating from "vue-star-rating";
import OrderTable from "components/OrderTable.vue";
import HeaderAgg from "components/Table/HeaderAgg.vue";
import CheckBox from "components/CheckBox.vue";
import ShareCandidate from "@/Recruiters/Applies/ShareCandidate.vue";
import ChangeSelectiveProcess from "@/Recruiters/Applies/ChangeSelectiveProcess.vue";
import vPagination from "vue-plain-pagination";

import { state, gettersMap, mutationsMap } from "store/table.js";

export default {
  components: { ApplyShow, StarRating, OrderTable, CheckBox, vPagination, HeaderAgg },
  props: [
    "job",
    "selective_processes",
    "shortlist_uid",
    "info_tags",
    "recruiter_id",
    "is_admin",
    "is_limited"
  ],
  data: () => ({
    status: ["Não avaliado", "Visualizado", "Avaliado"],
    search: "",
    kanban: false,
    visibility: false,
    complete_videos: false,
    curriculum: false,
    applies: [],
    field: "",
    order: "",
    selected: [],
    selected_ids: [],
    firstLoad: true,
    loading: false,
    totalApplies: 0,
    currentPage: 2,
    pageCount: 1,
    state: state,
    bootstrapPaginationClasses: {
      ul: "pagination",
      li: "page-item",
      liActive: "active",
      liDisable: "disabled",
      button: "page-link",
    },
    ethnicities: [
      { id: null, name: "Não cadastrado" },
      { id: 0, name: "Indígena" },
      { id: 1, name: "Branco" },
      { id: 2, name: "Negro" },
      { id: 3, name: "Pardo" },
      { id: 4, name: "Oriental" },
      { id: 5, name: "Prefiro não informar" },
      { id: 6, name: "Indefinido" },
    ],
    genders: [
      { id: null, name: "Não cadastrado" },
      { id: -1, name: "Não cadastrado" },
      { id: 0, name: "Cisgênero Masculino" },
      { id: 1, name: "Cisgênero Feminino" },
      { id: 2, name: "Transgênero" },
      { id: 4, name: "Não Binário" },
      { id: 3, name: "Prefiro não informar" },
      { id: 10, name: "Outros" }
    ],
    sexual_orientations: [
      { id: null, name: "Não cadastrado" },
      { id: 0, name: "Heterossexual" },
      { id: 1, name: "Bissexual" },
      { id: 2, name: "Pansexual" },
      { id: 4, name: "Homossexual" },
      { id: 3, name: "Prefiro não informar" },
    ],
    aggs: [],
    action: "",
  }),
  methods: {
    haveRightAnswer(question) {
      let excluded_types = [0, 1, 4];
      if (excluded_types.includes(question.response_type)) return false;

      let choices = question.choices;
      if (choices.correctAnswer && choices.correctAnswer != "any") return true;

      if (question.response_type == 2) {
        return (
          choices.rightAnswers.length > 0 &&
          choices.rightAnswers.length != choices.options.length
        );
      }

      return false;
    },
    hitsPercentage(apply) {
      // let questions_count = this.job.questions.filter((question) =>
      //   this.haveRightAnswer(question)
      // ).length;

      if (apply.candidate_created_at > this.job.date_conclusion) {
        return "Prova expirada";
      }

      let questions_count = this.job.questions.length;

      let percentage = Math.floor((apply.point * 100) / questions_count);

      if (questions_count == 0 || apply.answers.length == 0) {
        return "Não aplicável";
      }
      percentage = `${apply.answers_percentage ?? 'NÃO POSSUI PORCENTAGEM'}`
      apply.hitsPercentage = `${apply.answers_percentage ?? 'NÃO POSSUI PORCENTAGEM'}`;
      return `${percentage} %`;
    },
    changeAction() {
      if (this.action == 1) {
        this.showShareCandidate();
      }
      if (this.action == 2) {
        this.showChangeStatus();
      }
      if (this.action == 3) {
        this.showRemoveCandidate();
      }
      if (this.action == 4) {
        this.downloadCandidates();
      }
    },
    changeOrder(field, order) {
      this.field = field;
      this.order = order;
    },
    formattedDate(date) {
      return moment(date, "YYYY-MM-DD").format("DD/MM/YYYY");
    },
    searchApplies() {
      if (this.search != "") {
        this.selected = [];
        this.selected_ids = [];
        eventBus.$emit("no_check", true);
      }
      let params = {};

      if (this.field != "") {
        params["order"] = {};
        params["order"][this.field] = this.order;
      }
      params["search"] = this.search;
      params["where"] = JSON.stringify(gettersMap.getWhere());
      if (this.visibility) params["visibility"] = this.visibility;
      if (this.curriculum) params["curriculum"] = this.curriculum;
      if (this.complete_videos)
        params["complete_videos"] = this.complete_videos;

      this.loading = true;
      axios
        .get(
          `/recruiters/jobs/${this.job.id}/applies/search/${this.currentPage}`,
          {
            params: params,
          }
        )
        .then((response) => {
         
          this.aggs =  response.data.applies.aggs;
          console.log(this.aggs);
          this.applies = response.data.applies.apply_search;
          this.totalApplies = response.data.applies.total_applies;
          this.pageCount = Math.ceil(this.totalApplies / 15);
          this.firstLoad = false;
          this.loading = false;
       
        });
    },
    showChangeStatus() {
      this.$modal.show(
        ChangeSelectiveProcess,
        {
          job_id: this.job.id,
          applies: this.applies,
          apply_ids: this.selected,
          selective_processes: this.selective_processes,
          selected: this.selected,
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.searchApplies();
            this.action = 0;
          },
        }
      );
    },
    showShareCandidate() {
      this.$modal.show(
        ShareCandidate,
        {
          job_id: this.job.id,
          apply_ids: this.selected_ids,
          selective_processes: this.selective_processes,
        },
        {
          width: "75%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.searchApplies();
            this.action = 0;
          },
        }
      );
    },
    showRemoveCandidate() {
      const confirm = window.confirm(
        "Tem certeza que deseja excluir o(s) candidato(s) desse processo seletivo?"
      );
      let promises = [];
      if (confirm) {
        this.selected_ids.forEach((id) => {
          promises.push(
            axios.put(`/recruiters/applies/${id}`, {
              applies: {
                visibility: false,
              },
            })
          );
        });
        Promise.all(promises).then(() => {
          this.$toast.success(
            "Candidato(s) removido(s) deste processo com sucesso!"
          );
          setTimeout(() => {
            this.searchApplies();
          }, 500);
        });
      }
    },
    show(apply_id, candidate_id, index) {
      this.$modal.show(
        ApplyShow,
        {
          index: index,
          applies: this.applies,
          job_id: this.job.id,
          job_name: this.job.title,
          apply_id: apply_id,
          candidate_id: candidate_id,
          user_manager: false,
          talent_bank_id: this.applies[index].talent_bank_id,
          recruiter_id: this.recruiter_id,
          hitsPercentage: this.applies[index].hitsPercentage,
          is_limited: this.is_limited,
        },
        {
          width: "90%",
          height: "auto",
          scrollable: true,
        },
        {
          "before-close": (event) => {
            this.searchApplies();
            this.action = 0;
          },
        }
      );
    },
    getEthnicity(ethnicity_id) {
      const ethnicity = this.ethnicities.find(
        (ethnicity) => ethnicity.id === ethnicity_id
      );
      if (ethnicity) {
        return ethnicity.name;
      }
      return "Não definido";
    },
    getGender(gender_id) {
      const gender = this.genders.find(
        (gender) => gender.id === gender_id
      );
      if (gender) {
        return gender.name;
      }
      return "Não definido";
    },
    getSexualOrientation(sexual_orientation_id) {
      const sexual_orientation = this.sexual_orientations.find(
        (sexual_orientation) => sexual_orientation.id === sexual_orientation_id
      );
      if (sexual_orientation) {
        return sexual_orientation.name;
      }
      return "Não definido";
    },
    downloadCandidates() {
      this.selected.forEach((selected) => {
        this.download_file(`/recruiters/applies/${selected.id}/download.pdf`, 'Curriculo');
      });
    },
    download_file(fileURL, fileName) {
      if(fileURL) {
        var save = document.createElement('a');
        save.href = fileURL;
        save.target = '_blank';
        var filename = fileURL.substring(fileURL.lastIndexOf('/')+1);
        save.download = fileName || filename;
        if ( navigator.userAgent.toLowerCase().match(/(ipad|iphone|safari)/) && navigator.userAgent.search("Chrome") < 0) {
          document.location = save.href; 
        }else{
          var evt = new MouseEvent('click', {
            'view': window,
            'bubbles': true,
            'cancelable': false
          });
          if(save.href){
            save.dispatchEvent(evt);
            (window.URL || window.webkitURL).revokeObjectURL(save.href);
          }
        }
      }
    }
  },
  mounted() {
    this.action = 0;
    eventBus.$on("orderColumnapplies", (fields) => {
      this.field = fields.field;
      this.order = fields.order;
      this.searchApplies();
    });

    eventBus.$on("resetSelected", () => {
      this.selected = [];
      this.selected_ids = [];
      eventBus.$emit("no_check", true);
    });

    eventBus.$on("checkbox", (fields) => {
      let index_id = -1;
      for (let i in this.selected) {
        if (this.selected[i].id == fields.id.id) {
          index_id = i;
          break;
        }
      }
      if (index_id != -1) this.selected.splice(index_id, 1);

      const index_i = this.selected_ids.indexOf(fields.id.id);
      if (index_i > -1) this.selected_ids.splice(index_i, 1);

      if (fields.operator) {
        this.selected.push(fields.id);
        this.selected_ids.push(fields.id.id);
      }
    });
    this.searchApplies();
  },

  watch: {
    "state.where"() {
      this.searchApplies();
    },
    currentPage: function () {
      console.log(this.currentPage);
      this.searchApplies();
    },
    visibility: function () {
      this.searchApplies();
    },
    complete_videos: function () {
      this.searchApplies();
    },
    curriculum: function () {
      this.searchApplies();
    },
  }
};
</script>

<style>
.chip{
  padding: 3px;
  background-color: #f5f5f5;
  margin-right: 3px;
  border-radius: 10px;
}
</style>